<template>
  <div class="order-detail">
    <header>
      <div class="bottom" v-if="data.descData">
        <div class="left">
          <p class="status-title">{{ data.descData.text.detail_title }}</p>
          <div v-if="data.descData.id == 1" class="status-detail">
            您的订单已提交，请在
            <van-count-down :time="data.order_time_out" format="mm分ss秒" @finish="onTimeFinish"></van-count-down>内完成支付，超时订单自动取消
          </div>
          <div v-else-if="data.descData.id == 4" class="status-detail">
            <div v-if="data.logistics_info.auto_confirm_at == -1">卖家已发货，请尽快确认收货</div>
            <div v-else>
              您的订单已发货，请在
              <van-count-down
                :time="data.logistics_info.auto_confirm_at"
                format="HH时mm分ss秒"
                @finish="onConfirmTimeFinish"
              ></van-count-down>内确认收货，超时系统将自动确认
            </div>
          </div>
          <p v-else class="status-detail">{{ data.descData.text.detail_more }}</p>
        </div>
        <img class="tag" src="@/assets/images/order/header-tag.png" />
      </div>
    </header>
    <div class="content">
      <div class="section-logistics section" v-if="data.logistics_info">
        <img class="icon" src="@/assets/images/order/icon-logistics.png" />
        <div>
          <p class="name">{{ data.logistics_info.logistics_name }}</p>
          <p class="no">{{ data.logistics_info.logistics_no }}</p>
        </div>
      </div>
      <div class="section-address section" v-if="data.address_info">
        <img class="icon" src="@/assets/images/order/icon-address.png" />
        <div>
          <p>
            <span class="name">
              {{
              data.address_info.consignee || "无名氏"
              }}
            </span>
            <span class="mobile">{{ data.address_info.consignee_mobile }}</span>
          </p>
          <p class="address">{{ address }}</p>
        </div>
      </div>
      <div class="section-title section">
        <div class="wrapper book" v-if="data.shop_type == 12">
          <img class="cover" :src="data.cover_img" />
          <div class="title-box">
            <p class="title">{{ data.shop_name }}</p>
            <div class="price-box">
              <span class="price">
                <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
                {{ data.product_price | toFixPrice }}
              </span>
            </div>
            <div class="count">x{{ data.product_number }}</div>
          </div>
        </div>
        <div class="wrapper" v-else>
          <p class="title-box vmiddle">
            <span class="tag-group" v-if="data.spell_id">{{ data.user_num }}人团</span>
            <span class="tag-course" v-if="data.shop_type <= 10">
              {{
              data.shop_type_name
              }}
            </span>
            <span class="title">{{ data.shop_name }}</span>
          </p>
          <p class="item">
            <span
              class="period"
              v-if="data.shop_type <= 10 && data.shop_type != 1"
            >共{{ data.periods_num }}课时</span>
            <span class="price">
              <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
              {{ data.product_price | toFixPrice }}
            </span>
          </p>
        </div>
        <div class="wrapper">
          <p class="item">
            <span>订单编号：</span>
            <span>{{ data.order_number }}</span>
          </p>
          <p class="item">
            <span>下单时间：</span>
            <span>
              {{
              data.created_at | fomartTime("yyyy/MM/dd hh:mm:ss")
              }}
            </span>
          </p>
          <p class="item" v-if="data.pay_time">
            <span>支付时间：</span>
            <span>{{ data.pay_time | fomartTime("yyyy/MM/dd hh:mm:ss") }}</span>
          </p>
          <p class="item" v-if="data.pay_type_name">
            <span>支付方式：</span>
            <span>{{ data.pay_type_name }}</span>
          </p>
        </div>
      </div>
      <div class="section-price section">
        <p class="item">
          <span>商品价格：</span>
          <span>
            <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
            {{ data.shopPrice | toFixPrice }}
          </span>
        </p>
        <p class="item" v-if="data.is_virtual == 2">
          <span>运费：</span>
          <span>
            <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
            {{ data.ship_price | toFixPrice }}
          </span>
        </p>
        <p class="item" v-if="data.shop_type != 14 && config.switch_coupon_module == 1">
          <span>优惠券：</span>
          <span>
            -
            <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
            {{ data.coupon_discount | toFixPrice }}
          </span>
        </p>
        <p class="item real-price">
          <span class="label">实付金额：</span>
          <span class="price">
            <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
            {{ data.realPrice | toFixPrice }}
          </span>
        </p>
      </div>
      <div class="section-refund section" v-if="showRefund">
        <template v-if="data.refund_status == 3">
          <div class="wrapper">
            <p class="refund-title">退款被驳回</p>
          </div>
          <div class="wrapper">
            <p class="item">
              <span>下单时间：</span>
              <span>
                {{
                data.refund_refuse_time | fomartTime("yyyy/MM/dd hh:mm:ss")
                }}
              </span>
            </p>
            <p class="item">
              <span>原因：</span>
              <span>{{ data.remark || "--" }}</span>
            </p>
          </div>
        </template>
        <template v-else>
          <div class="wrapper">
            <p class="refund-title">{{ data.descData.text.detail_refund }}</p>
          </div>
          <div class="wrapper" v-if="data.descData.id == 9">
            <p class="item">
              <span>失败原因：</span>
              <span>{{ data.err_msg || "--" }}</span>
            </p>
          </div>
          <div class="wrapper" v-else-if="data.descData.id == 10">
            <p class="item">
              <span>退款金额：</span>
              <span class="refund-price">
                <icon-price size="middle" :priceType="data.is_virtual"></icon-price>
                {{ data.refund_price | toFixPrice }}
              </span>
            </p>
            <p class="item">
              <span>备注：</span>
              <span>{{ data.remark || "--" }}</span>
            </p>
          </div>
        </template>
      </div>
    </div>
    <order-buttons
      :data="data"
      :order-type="orderType"
      @on-reset="requestDetail"
      @on-eval="onEval"
      @on-invite="onInvite"
    ></order-buttons>
    <Evaluating ref="comment" @refresh="requestDetail" com_type="3"></Evaluating>
    <Share ref="share" :group-id="data.group_id"></Share>
    <back-spell v-if="data.spell_id"></back-spell>
  </div>
</template>

<script>
import { OrderStatus, ShipStatus, PayType, ShopType } from "@/util/enums";
import OrderButtons from "./OrderButtons";
import Evaluating from "@/components/Evaluating";
import Share from "@/components/group/Share.vue";
export default {
  name: "order-detail",
  components: {
    OrderButtons,
    Evaluating,
    Share
  },
  data() {
    return {
      order_id: this.$route.query.order_id,
      data: {},
      orderType: this.$route.query.order_type
    };
  },
  computed: {
    showRefund() {
      if (this.data.refund_status == 3) {
        return true;
      }
      if (this.data.descData) {
        switch (this.data.descData.id) {
          case 7:
          case 8:
          case 9:
          case 10:
            return true;
        }
      }
      return false;
    },
    address() {
      let ret = "";
      const info = this.data.address_info;
      if (info) {
        ret += info.province_name || "";
        ret += info.city_name || "";
        ret += info.district_name || "";
        ret += info.address;
      }
      return ret;
    },
    config() {
      return this.$store.state.config;
    }
  },
  created() {
    this.requestDetail();
  },
  methods: {
    // on event
    onTimeFinish() {
      // 到时间自动取消订单
      this.$http
        .post("/api/app/myOrder/cancel", { order_id: this.data.id })
        .then(() => {
          this.requestDetail();
        });
    },
    onConfirmTimeFinish() {
      // 到时间自动确认收货
      this.$http.put(`/api/app/orderShip/confirm/${this.data.id}`).then(() => {
        this.requestDetail();
      });
    },
    onEval() {
      this.$refs.comment.showBox({
        id: this.data.shop_ids,
        order_number: this.data.order_number
      });
    },
    onInvite() {
      this.$refs.share.display();
    },
    // request
    requestDetail() {
      this.$http
        .post("/api/app/myOrder/detail", {
          order_id: this.order_id
        })
        .then(data => {
          // test code
          // data.order_status = 1;
          // data.pay_status = 2;
          // data.ship_status = 3;
          // data.logistics_info = {
          //   logistics_name: "圆通快递",
          //   logistics_no: "8988768876689",
          //   auto_confirm_at: 80000
          // };

          data.descData = this.$pub.order.getDetailDescData(data);
          data.order_status_name = OrderStatus.getValue(data.order_status);
          data.pay_type_name = PayType.getValue(data.pay_type);
          data.ship_status_name = ShipStatus.getValue(data.ship_status);
          data.shop_type_name = this.config.course_name[data.shop_type];
          data.order_time_out *= 1000;
          if (
            data.logistics_info &&
            data.logistics_info.auto_confirm_at != -1
          ) {
            data.logistics_info.auto_confirm_at *= 1000;
          }
          // 计算商品价格：单价*数量
          data.shopPrice = data.product_price * data.product_number;
          // 计算实付金额
          data.realPrice = data.order_price + data.ship_price;
          this.data = data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail {
  @extend %default-bg;
  header {
    background: linear-gradient(
      180deg,
      rgba(99, 183, 254, 1) 0%,
      rgba(78, 125, 227, 1) 100%
    );
    .bottom {
      padding: 40px 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .status-title {
        font-size: 26px;
        font-weight: 500;
        color: #fff;
      }
      .status-detail {
        margin-top: 20px;
        width: 370px;
        font-size: 22px;
        line-height: 34px;
        font-weight: 400;
        color: #ddd;
        .van-count-down {
          display: inline-block;
          color: #ddd;
        }
      }
      .tag {
        width: 200px;
      }
    }
  }
  .content {
    padding: 26px 20px 250px 20px;
    font-size: 26px;
    color: #8c8c8c;
    .section {
      padding: 30px;
      border-radius: 15px;
      background-color: #fff;
      margin-bottom: 20px;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        span:first-child {
          white-space: nowrap;
        }
      }
      .wrapper {
        border-bottom: 1px solid #f5f5f5;
        padding: 25px 0;
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          padding-bottom: 0;
          border-bottom: none;
        }
      }
    }
    .section-logistics {
      display: flex;
      align-items: center;
      .icon {
        width: 58px;
        margin-right: 20px;
      }
      .name {
        font-size: 26px;
        color: #3a97de;
        margin-bottom: 20px;
      }
      .no {
        font-size: 22px;
      }
    }
    .section-address {
      display: flex;
      align-items: center;
      .icon {
        width: 58px;
        margin-right: 20px;
        flex: none;
      }
      .name {
        font-size: 28px;
        color: #20242a;
        margin-right: 12px;
      }
      .mobile {
        font-size: 24px;
      }
      .address {
        margin-top: 20px;
        font-size: 22px;
        line-height: 30px;
        color: #20242a;
      }
    }
    .section-title {
      .book {
        display: flex;
        .cover {
          flex: none;
          width: 132px;
          height: 184px;
          margin-right: 30px;
        }
        .title-box {
          flex-grow: 1;
          margin-bottom: 0;
        }
        .title {
          line-height: 38px;
        }
        .price-box {
          text-align: right;
        }
        .count {
          text-align: right;
          margin-top: 20px;
        }
      }
      .title-box {
        display: block;
        margin-bottom: 20px;
      }
      .tag-group {
        font-size: 24px;
        color: #ee1f1f;
        background-color: rgba(238, 31, 31, 0.1);
        border-radius: 4px;
        padding: 2px 4px;
        margin-right: 12px;
      }
      .tag-course {
        font-size: 24px;
        color: #ea7a2f;
        background-color: rgba(234, 122, 47, 0.1);
        border-radius: 4px;
        padding: 2px 4px;
        margin-right: 12px;
      }
      .title {
        font-size: 28px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 20px;
      }
      .period {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.45);
      }
      .price {
        font-size: 32px;
        color: #ee1f1f;
      }
    }
    .section-price {
      .real-price {
        font-size: 28px;
        .label {
          color: #595959;
        }
        .price {
          color: #ee1f1f;
        }
      }
    }
    .section-refund {
      .refund-title {
        font-size: 28px;
        color: #595959;
      }
      .refund-price {
        font-size: 28px;
        color: #ee1f1f;
      }
    }
  }
  .order-buttons {
    background-color: #fff;
    box-shadow: 0px -10px 16px 0px rgba(0, 0, 0, 0.02);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    /deep/ {
      .btn {
        margin-top: 22px;
        margin-bottom: 22px;
        &:last-child {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>
